var render = function render(){
  var _vm$payload, _vm$payload2, _vm$payload3, _vm$payload3$serviceT, _vm$payload4, _vm$payload5, _vm$payload6, _vm$payload7, _vm$$helper, _vm$payload8, _vm$$helper$findColor, _vm$$masterCrm, _vm$payload9, _vm$$helper$findColor2, _vm$$masterCrm2, _vm$payload10, _vm$payload11, _vm$payload12, _vm$payload13, _vm$payload14, _vm$payload14$equipme, _vm$payload15, _vm$payload15$brand, _vm$payload16, _vm$payload16$categor, _vm$payload17, _vm$payload18, _vm$payload19, _vm$payload20, _vm$payload21;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container-wrapper"
  }, [_vm.isFetching ? _c('div', {
    staticClass: "container-wrap"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container-wrap"
  }, [(_vm$payload = _vm.payload) !== null && _vm$payload !== void 0 && _vm$payload.id ? _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "title-item"
  }, [_vm._v("Request Information")]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "content-item-card"
  }, [_vm._m(1), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Subject")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload2 = _vm.payload) === null || _vm$payload2 === void 0 ? void 0 : _vm$payload2.subject) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Service Type")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload3 = _vm.payload) === null || _vm$payload3 === void 0 ? void 0 : (_vm$payload3$serviceT = _vm$payload3.serviceType) === null || _vm$payload3$serviceT === void 0 ? void 0 : _vm$payload3$serviceT.name) || ((_vm$payload4 = _vm.payload) === null || _vm$payload4 === void 0 ? void 0 : _vm$payload4.serviceTypeName) || ((_vm$payload5 = _vm.payload) === null || _vm$payload5 === void 0 ? void 0 : _vm$payload5.serviceType) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Number of Barista")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(String(((_vm$payload6 = _vm.payload) === null || _vm$payload6 === void 0 ? void 0 : _vm$payload6.numberOfBarista) || "0").padStart(2, "0")))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Provider")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload7 = _vm.payload) === null || _vm$payload7 === void 0 ? void 0 : _vm$payload7.provider) || "Ecommerce"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Created At")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s((_vm$$helper = _vm.$helper) === null || _vm$$helper === void 0 ? void 0 : _vm$$helper.formatDate((_vm$payload8 = _vm.payload) === null || _vm$payload8 === void 0 ? void 0 : _vm$payload8.createdAt)))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Status")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_c('span', {
    style: {
      color: (_vm$$helper$findColor = _vm.$helper.findColor((_vm$$masterCrm = _vm.$masterCrm) === null || _vm$$masterCrm === void 0 ? void 0 : _vm$$masterCrm.CrmCaseStatus, (_vm$payload9 = _vm.payload) === null || _vm$payload9 === void 0 ? void 0 : _vm$payload9.caseStatusId, ['id'])) === null || _vm$$helper$findColor === void 0 ? void 0 : _vm$$helper$findColor.textColor
    }
  }, [_vm._v(" " + _vm._s(((_vm$$helper$findColor2 = _vm.$helper.findColor((_vm$$masterCrm2 = _vm.$masterCrm) === null || _vm$$masterCrm2 === void 0 ? void 0 : _vm$$masterCrm2.CrmCaseStatus, (_vm$payload10 = _vm.payload) === null || _vm$payload10 === void 0 ? void 0 : _vm$payload10.caseStatusId, ['id'])) === null || _vm$$helper$findColor2 === void 0 ? void 0 : _vm$$helper$findColor2.name) || 'N/A') + " ")])])])]), false ? _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Remark")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload11 = _vm.payload) === null || _vm$payload11 === void 0 ? void 0 : _vm$payload11.remark) || "N/A"))])])]) : _vm._e(), false ? _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Photo")]), _c('span', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_c('image-detail', {
    attrs: {
      "heightChange": '294px',
      "widthChange": '294px',
      "objectFit": 'cover',
      "radiusChange": '10px',
      "thumbnail": ((_vm$payload12 = _vm.payload) === null || _vm$payload12 === void 0 ? void 0 : _vm$payload12.attachment) && _vm.getFullImage((_vm$payload13 = _vm.payload) === null || _vm$payload13 === void 0 ? void 0 : _vm$payload13.attachment) || require('@/assets/images/noImage.jpg')
    }
  })], 1)])]) : _vm._e()]), _c('div', {
    staticClass: "content-item-card",
    staticStyle: {
      "border": "none",
      "gap": "30px"
    }
  }, [false ? _c('div', {
    staticClass: "content-item-card-wrapper"
  }, [_vm._m(2), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Name")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload14 = _vm.payload) === null || _vm$payload14 === void 0 ? void 0 : (_vm$payload14$equipme = _vm$payload14.equipmentInfo) === null || _vm$payload14$equipme === void 0 ? void 0 : _vm$payload14$equipme.itemName) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Brand")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload15 = _vm.payload) === null || _vm$payload15 === void 0 ? void 0 : (_vm$payload15$brand = _vm$payload15.brand) === null || _vm$payload15$brand === void 0 ? void 0 : _vm$payload15$brand.name) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Category")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload16 = _vm.payload) === null || _vm$payload16 === void 0 ? void 0 : (_vm$payload16$categor = _vm$payload16.category) === null || _vm$payload16$categor === void 0 ? void 0 : _vm$payload16$categor.name) || "N/A"))])])])]) : _vm._e(), _c('div', {
    staticClass: "content-item-card-wrapper"
  }, [_vm._m(3), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Name")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload17 = _vm.payload) === null || _vm$payload17 === void 0 ? void 0 : _vm$payload17.bpName) || ((_vm$payload18 = _vm.payload) === null || _vm$payload18 === void 0 ? void 0 : _vm$payload18.customerName) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Phone Number")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(" " + _vm._s(_vm.$helper.formatPhoneNumber((_vm$payload19 = _vm.payload) === null || _vm$payload19 === void 0 ? void 0 : _vm$payload19.contactPhoneNumber)) + " ")])])])]), _c('div', {
    staticClass: "content-item-card-wrapper"
  }, [_vm._m(4), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Name")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload20 = _vm.payload) === null || _vm$payload20 === void 0 ? void 0 : _vm$payload20.addressName) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Address")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload21 = _vm.payload) === null || _vm$payload21 === void 0 ? void 0 : _vm$payload21.addressDetail) || "N/A"))])])])])])])]) : _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "title-item"
  }, [_vm._v("Request Information")]), _vm._m(5)]), _c('div', {
    staticClass: "form-footer",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-secondary",
    staticStyle: {
      "min-width": "130px"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" BAck ")])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-item",
    staticStyle: {
      "min-height": "200px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "loader-circle"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item-card-header"
  }, [_c('span', [_vm._v("Request Detail")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item-card-header"
  }, [_c('span', [_vm._v("Equipment")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item-card-header"
  }, [_c('span', [_vm._v("Contact Information")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item-card-header"
  }, [_c('span', [_vm._v("Location")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item",
    staticStyle: {
      "height": "150px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('span', [_vm._v("Invalid Request")])]);

}]

export { render, staticRenderFns }